import {Suspense} from 'react'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {CheckCircleIcon} from '@primer/octicons-react'
import {ForYouItem} from './shared/ForYouItem'
import {ForYouLeadingIcon} from './shared/ForYouLeadingIcon'
import {useViewerOwnsPullRequest, useViewerIsReviewer} from './shared/ForYouItemBoundary'

/**
 * Rendered when the viewer has no actionable "For You" items. Only shown to
 * people responsible for moving the PR forward — the author, an assignee, or a
 * requested reviewer — so they can rely on For You as the way to orient
 * themselves to what's actionable on the page.
 */
export function ForYouEmptyState() {
  return (
    <ErrorBoundary boundaryName="ForYouEmptyState" fallback={null}>
      <Suspense fallback={null}>
        <ForYouEmptyStateForResponsibleViewer />
      </Suspense>
    </ErrorBoundary>
  )
}

function ForYouEmptyStateForResponsibleViewer() {
  const viewerOwnsPullRequest = useViewerOwnsPullRequest()
  const viewerIsReviewer = useViewerIsReviewer()
  if (!viewerOwnsPullRequest && !viewerIsReviewer) return null

  return (
    // eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals
    <ul className="List-style-none p-0 m-0 d-flex flex-column gap-2">
      <ForYouItem
        leadingVisual={<ForYouLeadingIcon icon={CheckCircleIcon} variant="success" />}
        title="You're all caught up. Nothing for you to do"
        itemName="nothing_to_act_on"
      />
    </ul>
  )
}
